import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=7bf003c2&"
import script from "./EditRole.vue?vue&type=script&lang=js&"
export * from "./EditRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports